var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLtcLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "#32C5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3966 35.7235L28.0499 29.498L31.9642 28.0679L32.9378 24.4092L32.9046 24.3185L29.0515 25.7261L31.8277 15.2727H23.9544L20.3238 28.9146L17.2925 30.022L16.2909 33.7939L19.3199 32.6874L17.1801 40.7272H38.1341L39.4774 35.7235H26.3966Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLtcLg);
export default __webpack_public_path__ + "static/media/icon-ltc-lg.65c45472.svg";
export { ForwardRef as ReactComponent };